import { render, staticRenderFns } from "./LoanFactorsBox.vue?vue&type=template&id=50aa158f&scoped=true"
import script from "./LoanFactorsBox.vue?vue&type=script&lang=js"
export * from "./LoanFactorsBox.vue?vue&type=script&lang=js"
import style0 from "./LoanFactorsBox.vue?vue&type=style&index=0&id=50aa158f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50aa158f",
  null
  
)

export default component.exports